import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useTemplateEditorContext } from './TemplateEditorContext'

interface TemplateUnsavedGuardProps {
  open: boolean
  selectedId: string | 'new'
  onKeepEditing: () => void
  onDiscard: () => void
  onSaveAndClose: () => void
}

export const TemplateUnsavedGuard = ({
  open,
  selectedId,
  onKeepEditing,
  onDiscard,
  onSaveAndClose,
}: TemplateUnsavedGuardProps) => {
  const { t } = useTranslation('@cibo/programs/TemplateEditorModal')
  const { canSave, isSaving, hasName, onNameAndSave } = useTemplateEditorContext()
  const context = selectedId !== 'new' ? 'changes' : 'new'

  return (
    <Dialog open={open} onClose={onKeepEditing}>
      <DialogTitle>{t('unsavedChangesTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('unsavedChangesMessage', { context })}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onKeepEditing}>{t('keepEditing')}</Button>
        <Button color="error" onClick={onDiscard}>
          {t('discardChanges', { context })}
        </Button>
        {hasName ? (
          <Button
            variant="contained"
            loading={isSaving}
            disabled={!canSave}
            onClick={onSaveAndClose}
          >
            {t('saveAndClose')}
          </Button>
        ) : (
          <Button variant="contained" onClick={onNameAndSave}>
            {t('nameAndSave')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
